import React from "react";
import { Phone, Calendar, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Herohorizon() {
  const stats = [{
    value: "2",
    label: "Active Artists"
  }, {
    value: "4",
    label: "Core Genres"
  }];
  return <section data-section-id="257521" id="herohorizon" className="bg-background text-foreground relative w-full overflow-hidden">
      {}
      <div className="container mx-auto px-4 max-w-[1200px] py-16 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="space-y-8 text-center">
            <div className="flex items-center justify-center gap-3 text-accent font-default font-semibold tracking-widest uppercase text-sm">
              <span className="w-10 h-[2px] bg-accent block"></span>
              Michigan Based Label
            </div>
            
            <h1 className="text-5xl lg:text-[60px] leading-[1.1] font-default font-bold text-foreground">
              Elevating Independent <br /> Artists Beyond <br /> the <span className="text-secondary drop-shadow-[0_0_15px_rgba(255,23,171,0.5)]">Horizon</span>
            </h1>
            
            <p className="text-lg font-sans text-muted-foreground max-w-lg leading-relaxed">Heavens Horizons Records LLC is a creative home for EDM, Pop, and Rock visionaries. We would love for you to grow with us.</p>
            
            <div className="flex flex-wrap gap-4 pt-2">
              <Button asChild size="lg" className="bg-secondary hover:bg-secondary/90 text-white rounded-md px-8 h-14 text-base shadow-lg shadow-secondary/20">
                <Link to="/ArtistsPage">
                  Meet the Artists
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-md px-8 h-14 text-base border-2 border-accent/50 text-accent hover:bg-accent/10 hover:text-accent shadow-sm backdrop-blur-sm">
                <Link to="/SubmissionsPage">
                  Submit Demo
                </Link>
              </Button>
            </div>
            
            {}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-10 border-t border-border/60 justify-items-center text-center">
              {stats.map((stat, i) => <div key={i} data-index={i} className="space-y-1">
                  <div className="text-3xl font-default font-bold text-foreground">{stat.value}</div>
                  <div className="text-sm font-sans text-muted-foreground font-medium">{stat.label}</div>
                </div>)}
            </div>
          </div>

          {}
          <div className="relative h-[400px] sm:h-[500px] lg:h-[650px] w-full rounded-lg overflow-hidden shadow-2xl shadow-accent/10 border border-white/5">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/heavens_horizons_studio_neon.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/heavens_horizons_studio_neon.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689432/img/heavens_horizons_studio_neon.png-wvc-sizes" alt="Futuristic music studio with neon blue and pink lighting" className="absolute inset-0 w-full h-full object-cover" loading="eager" src="https://guiding-lionfish.10web.cloud/wp-content/uploads/2026/05/Our-mission-logo.png" />
            {}
            <div className="absolute bottom-6 right-6 bg-primary/80 backdrop-blur-md text-white px-5 py-3 rounded-md shadow-md flex items-center gap-3 border border-accent/30">
              <span className="font-bold font-default text-2xl text-accent">NEW</span>
              <span className="text-xs font-sans leading-tight font-medium uppercase tracking-wider">Latest<br />Releases</span>
            </div>
          </div>

        </div>
      </div>

      {}
      <div className="bg-primary text-primary-foreground py-5 border-t-4 border-secondary">
        <div className="container mx-auto px-4 max-w-[1200px] flex flex-col md:flex-row items-center justify-between gap-6">
          
          <div className="flex items-center gap-4">
            <div className="bg-accent/10 p-3 rounded-lg border border-accent/20">
              <ShieldAlert className="size-8 text-accent" />
            </div>
            <div>
              <div className="text-lg font-bold font-default tracking-wide">Artist Submissions Open</div>
              <div className="text-sm text-primary-foreground/80 font-sans mt-0.5">Join the Horizon - Reviewing Demos Weekly</div>
            </div>
          </div>
          
          <div className="flex flex-wrap items-center justify-center gap-4 w-full md:w-auto">
            <Button asChild className="bg-accent hover:bg-accent/90 text-accent-foreground rounded-md px-6 shadow-sm font-bold">
              <Link to="/SubmissionsPage">
                Apply Now
              </Link>
            </Button>
            <Button asChild variant="outline" className="border-primary-foreground/30 text-primary-foreground hover:bg-primary-foreground hover:text-primary rounded-md px-6 bg-transparent">
              <Link to="/ContactPage">
                Contact Us
              </Link>
            </Button>
          </div>

        </div>
      </div>
    </section>;
}